import React from 'react'
import { Container } from 'react-bootstrap';
import Bounce from 'react-reveal/Bounce';

export const Accessibility = () => (
  <Container>

    <div style={styles.container}>
      <Bounce right>
        <div style={styles.card}>

          <div style={styles.decorator}></div>

          <div style={styles.content}>

            <p style={styles.highlightText}>
              בהתאם לחוק הנגישות, לשם קבלת היתר זמני, רישיון עסק או חידוש רישיון:
            </p>
   <p style={styles.highlightText}>
נגישות לעסקים: המדריך המלא לקבלת רישיון עסק כחוק            </p>
            <p style={styles.mainText}>
              ערים מסוימות מחייבות את העסקים לעמוד בדרישות הנגישות בהתאם לחוק
              <span style={styles.boldBlue}> שוויון זכויות לאנשים עם מוגבלויות </span>
              ותקנותיו.
            </p>

<div style={styles.infoBox}> <p style={styles.introText}> מתכננים לפתוח עסק חדש? צריכים לחדש את רישיון העסק הקיים או לקבל היתר זמני? <strong> עמידה בחוק הנגישות היא כבר מזמן לא המלצה – היא תנאי סף מחייב לקבלת רישיון עסק בישראל.</strong> </p> <p style={styles.infoText}> על פי חוק שוויון זכויות לאנשים עם מוגבלויות, כל עסק המעניק שירות לציבור מחויב להנגיש את המקום ואת השירות בצורה מלאה. הרשויות המקומיות אוכפות דרישה זו בקפידה, ובלי אישור נגישות רשמי, לא ניתן לקבל רישיון עסק. </p> <p style={styles.infoText}> כדי לעבור את התהליך בהצלחה וללא עיכובים, עליכם להגיש לרשות המקומית חוות דעת מקצועיות משני מורשי נגישות: </p> {/* מורשה מתו"ס */} <div style={styles.expertBox}> <div style={styles.expertNumber}>1</div> <div> <h3 style={styles.expertTitle}> מורשה נגישות מתו"ס </h3> <p style={styles.smallText}> מבנים, תשתיות וסביבה </p> <p style={styles.infoText}> מורשה מתו"ס אחראי על כל המרכיבים הפיזיים וההנדסיים של המבנה. הוא בוחן את דרך הגישה של הלקוח מרגע הגעתו ועד לכניסתו לעסק. </p> <h4 style={styles.subTitle}> מה הוא בוחן בשטח? </h4> <ul style={styles.list}> <li>חניות נכים</li> <li>שיפועים ורמפות בכניסה</li> <li>רוחב פתחים ודלתות</li> <li>מעברים פנימיים חופשיים ממכשולים</li> <li>התאמה מלאה של תאי השירותים</li> </ul> </div> </div> {/* מורשה נגישות השירות */} <div style={styles.expertBox}> <div style={styles.expertNumber}>2</div> <div> <h3 style={styles.expertTitle}> מורשה נגישות השירות </h3> <p style={styles.infoText}> מורשה השירות מתמקד בחוויית הלקוח וברמת הנגישות של השירות הניתן בתוך העסק, מעבר לקירות המבנה. </p> <h4 style={styles.subTitle}> מה הוא בוחן בשטח? </h4> <ul style={styles.list}> <li>גובה דלפקי שירות וקופות</li> <li>התאמת ריהוט, כמו שולחנות נגישים</li> <li>מערכות עזר לשמיעה, כגון לולאות השראה</li> <li>שילוט ברור ומכוון</li> <li>נגישות אתר האינטרנט של העסק</li> <li>הדרכות ייעודיות לצוות העובדים למתן שירות נגיש</li> </ul> </div> </div> {/* תהליך האישור */} <div style={styles.processSection}> <h3 style={styles.sectionTitle}> איך עובד תהליך האישור מול הרשות המקומית? </h3> <div style={styles.processItem}> <span style={styles.processNumber}>01</span> <div> <strong style={styles.processTitle}> בדיקת המסמכים </strong> <p style={styles.smallInfoText}> מורשה נגישות מטעם הרשות יבחן את חוות הדעת ויוודא שהן עומדות בלשון החוק ובדרישות הדין. </p> </div> </div> <div style={styles.processItem}> <span style={styles.processNumber}>02</span> <div> <strong style={styles.processTitle}> ביקורת פיזית </strong> <p style={styles.smallInfoText}> נציגי הרשות יגיעו לסיור פיקוח בעסק כדי לוודא שכל הפתרונות שתוכננו אכן בוצעו בשטח במאת האחוזים. </p> </div> </div> <div style={styles.processItem}> <span style={styles.processNumber}>03</span> <div> <strong style={styles.processTitle}> מתן האישור </strong> <p style={styles.smallInfoText}> רק לאחר קבלת אישור ממורשה הנגישות של הרשות, תוכלו להתקדם לקבלת היתר זמני, רישיון עסק או חידוש הרישיון הקיים. </p> </div> </div> </div> {/* טיפ זהב */} <div style={styles.goldenTip}> <div style={styles.tipIcon}>★</div> <div> <h3 style={styles.tipTitle}> טיפ זהב לבעלי עסקים </h3> <p style={styles.tipText}> אל תחכו לרגע האחרון. מומלץ לערב מורשה נגישות כבר בשלב התכנון הראשוני של העסק, לפני השיפוץ, כדי למנוע טעויות בנייה קריטיות שתיקונן בשטח עלול לעלות לכם הרבה מאוד כסף וזמן יקר. </p> </div> </div> </div>

            {/* אזור חדש */}
            <div style={styles.requirementsSection}>
              <h3 style={styles.sectionTitle}>
                מה נדרש מבעל העסק?
              </h3>

              <div style={styles.items}>

                <div style={styles.item}>
                  <div style={styles.icon}>✓</div>
                  <div>
                    <strong style={styles.itemTitle}>
                      בדיקת נגישות
                    </strong>
                    <p style={styles.itemText}>
                      בחינת העסק והתאמתו לדרישות הנגישות הקבועות בחוק ובתקנות.
                    </p>
                  </div>
                </div>

                <div style={styles.item}>
                  <div style={styles.icon}>✓</div>
                  <div>
                    <strong style={styles.itemTitle}>
                      חוות דעת מקצועית
                    </strong>
                    <p style={styles.itemText}>
                      קבלת חוות דעת ממורשי נגישות מוסמכים בהתאם לסוג העסק ולדרישות הרשות.
                    </p>
                  </div>
                </div>

                <div style={styles.item}>
                  <div style={styles.icon}>✓</div>
                  <div>
                    <strong style={styles.itemTitle}>
                      עמידה בדרישות החוק
                    </strong>
                    <p style={styles.itemText}>
                      ביצוע ההתאמות הנדרשות לצורך קבלת היתר, רישיון עסק או חידושו.
                    </p>
                  </div>
                </div>

              </div>
            </div>

            <div style={styles.bottomNote}>
              <span style={styles.noteIcon}>💡</span>
              <span>
                חשוב לבצע את הבדיקה מראש, כדי למנוע עיכובים בתהליך קבלת הרישיון.
              </span>
            </div>

          </div>
        </div>
      </Bounce>
    </div>

  </Container>
);
const styles = {
  container: {
    direction: 'rtl',
    width: '100%',
    padding: '40px 20px',
    display: 'flex',
    justifyContent: 'center',
    boxSizing: 'border-box',
  },

  card: {
    width: '100%',
    maxWidth: '850px',
    backgroundColor: '#ffffff',
    borderRadius: '16px',
    boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
    overflow: 'hidden',
    position: 'relative',
    border: '1px solid #f0f0f0',
    boxSizing: 'border-box',
  },

  decorator: {
    height: '6px',
    width: '100%',
    backgroundImage: 'linear-gradient(to left, #3498db, #2ecc71)',
  },

  content: {
    padding: '40px',
    textAlign: 'right',
    boxSizing: 'border-box',
    minWidth: 0,
  },

  highlightText: {
    fontSize: '1.2rem',
    color: '#2c3e50',
    fontWeight: '600',
    marginBottom: '20px',
    lineHeight: '1.5',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },

  mainText: {
    fontSize: '1.1rem',
    color: '#546e7a',
    lineHeight: '1.8',
    marginBottom: '25px',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },

  boldBlue: {
    color: '#2980b9',
    fontWeight: '700',
  },

  infoBox: {
    backgroundColor: '#f8fafc',
    padding: '30px',
    borderRadius: '14px',
    borderRight: '5px solid #3498db',
    marginBottom: '30px',
    boxSizing: 'border-box',
    width: '100%',
    minWidth: 0,
  },

  introText: {
    fontSize: '1.15rem',
    color: '#263238',
    lineHeight: '1.9',
    marginBottom: '18px',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },

  infoText: {
    fontSize: '1rem',
    color: '#455a64',
    lineHeight: '1.8',
    marginBottom: '20px',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },

  expertBox: {
    display: 'flex',
    gap: '18px',
    padding: '22px',
    marginTop: '20px',
    marginBottom: '20px',
    backgroundColor: '#ffffff',
    borderRadius: '14px',
    border: '1px solid #e3eaf0',
    boxShadow: '0 4px 15px rgba(0,0,0,0.04)',
    boxSizing: 'border-box',
    width: '100%',
    minWidth: 0,
  },

  expertNumber: {
    flexShrink: 0,
    minWidth: '42px',
    width: '42px',
    height: '42px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #3498db, #2ecc71)',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
    fontSize: '1.1rem',
  },

  expertTitle: {
    margin: '0 0 3px',
    color: '#2980b9',
    fontSize: '1.25rem',
    fontWeight: '700',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },

  smallText: {
    margin: '0 0 12px',
    color: '#78909c',
    fontSize: '0.9rem',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },

  subTitle: {
    color: '#37474f',
    fontSize: '1rem',
    marginTop: '15px',
    marginBottom: '8px',
  },

  list: {
    margin: 0,
    paddingRight: '20px',
    color: '#546e7a',
    lineHeight: '2',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },

  processSection: {
    marginTop: '35px',
    paddingTop: '28px',
    borderTop: '1px solid #e1e8ed',
  },

  sectionTitle: {
    color: '#263238',
    fontSize: '1.35rem',
    fontWeight: '700',
    marginBottom: '25px',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },

  processItem: {
    display: 'flex',
    gap: '15px',
    marginBottom: '20px',
    alignItems: 'flex-start',
    minWidth: 0,
  },

  processNumber: {
    flexShrink: 0,
    minWidth: '45px',
    width: '45px',
    height: '45px',
    borderRadius: '10px',
    backgroundColor: '#eaf4fb',
    color: '#2980b9',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: '700',
    fontSize: '0.85rem',
  },

  processTitle: {
    color: '#2980b9',
    fontSize: '1.05rem',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },

  smallInfoText: {
    margin: '5px 0 0',
    color: '#607d8b',
    fontSize: '0.95rem',
    lineHeight: '1.7',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },

  goldenTip: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '15px',
    marginTop: '30px',
    padding: '22px',
    borderRadius: '14px',
    background: 'linear-gradient(135deg, #fff8e1, #fffdf5)',
    border: '1px solid #f5d98a',
    boxSizing: 'border-box',
    width: '100%',
    minWidth: 0,
  },

  tipIcon: {
    flexShrink: 0,
    minWidth: '38px',
    width: '38px',
    height: '38px',
    borderRadius: '50%',
    backgroundColor: '#f1c40f',
    color: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '18px',
  },

  tipTitle: {
    margin: '0 0 7px',
    color: '#9a7610',
    fontSize: '1.15rem',
    fontWeight: '700',
  },

  tipText: {
    margin: 0,
    color: '#6d5b23',
    lineHeight: '1.8',
    fontSize: '0.95rem',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },

  requirementsSection: {
    marginTop: '10px',
    paddingTop: '25px',
    borderTop: '1px solid #eeeeee',
  },

  items: {
    display: 'flex',
    flexDirection: 'column',
    gap: '18px',
  },

  item: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '15px',
    backgroundColor: '#ffffff',
    padding: '15px',
    borderRadius: '10px',
    border: '1px solid #edf2f7',
    boxSizing: 'border-box',
    minWidth: 0,
  },

  icon: {
    flexShrink: 0,
    minWidth: '32px',
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    backgroundColor: '#eaf7ef',
    color: '#27ae60',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
    fontSize: '18px',
  },

  itemTitle: {
    display: 'block',
    color: '#2980b9',
    fontSize: '1.05rem',
    marginBottom: '4px',
  },

  itemText: {
    margin: 0,
    color: '#607d8b',
    fontSize: '0.95rem',
    lineHeight: '1.6',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },

  bottomNote: {
    marginTop: '30px',
    padding: '15px 18px',
    borderRadius: '10px',
    backgroundColor: '#fff8e1',
    color: '#6d5b23',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    fontSize: '0.95rem',
    lineHeight: '1.6',
    boxSizing: 'border-box',
    width: '100%',
    minWidth: 0,
  },

  noteIcon: {
    flexShrink: 0,
    fontSize: '20px',
  },

  /* =========================================
     מובייל עד 768px
  ========================================= */

  '@media (max-width: 768px)': {
    container: {
      width: '100%',
      padding: '20px 10px',
      boxSizing: 'border-box',
    },

    card: {
      width: '100%',
      maxWidth: '100%',
      borderRadius: '12px',
    },

    content: {
      padding: '25px 15px',
      width: '100%',
    },

    highlightText: {
      fontSize: '1.05rem',
      lineHeight: '1.7',
    },

    mainText: {
      fontSize: '0.98rem',
      lineHeight: '1.8',
    },

    infoBox: {
      padding: '18px 14px',
    },

    introText: {
      fontSize: '1.02rem',
      lineHeight: '1.8',
    },

    infoText: {
      fontSize: '0.95rem',
      lineHeight: '1.75',
    },

    expertBox: {
      gap: '10px',
      padding: '16px 12px',
    },

    expertNumber: {
      minWidth: '38px',
      width: '38px',
      height: '38px',
      fontSize: '0.95rem',
    },

    expertTitle: {
      fontSize: '1.05rem',
    },

    smallText: {
      fontSize: '0.85rem',
    },

    subTitle: {
      fontSize: '0.95rem',
    },

    list: {
      paddingRight: '18px',
      fontSize: '0.9rem',
      lineHeight: '1.8',
    },

    processSection: {
      marginTop: '25px',
      paddingTop: '20px',
    },

    sectionTitle: {
      fontSize: '1.15rem',
      marginBottom: '18px',
    },

    processItem: {
      gap: '10px',
      padding: '14px 10px',
    },

    processNumber: {
      minWidth: '38px',
      width: '38px',
      height: '38px',
      fontSize: '0.75rem',
    },

    processTitle: {
      fontSize: '0.95rem',
    },

    smallInfoText: {
      fontSize: '0.88rem',
      lineHeight: '1.7',
    },

    requirementsSection: {
      marginTop: '25px',
      paddingTop: '20px',
    },

    item: {
      gap: '10px',
      padding: '13px 10px',
    },

    icon: {
      minWidth: '30px',
      width: '30px',
      height: '30px',
      fontSize: '16px',
    },

    itemTitle: {
      fontSize: '0.95rem',
    },

    itemText: {
      fontSize: '0.88rem',
    },

    goldenTip: {
      gap: '10px',
      padding: '16px 12px',
    },

    tipIcon: {
      minWidth: '34px',
      width: '34px',
      height: '34px',
      fontSize: '16px',
    },

    tipTitle: {
      fontSize: '1rem',
    },

    tipText: {
      fontSize: '0.88rem',
      lineHeight: '1.7',
    },

    bottomNote: {
      padding: '13px',
      fontSize: '0.88rem',
    },
  },

  /* =========================================
     מובייל קטן עד 480px
  ========================================= */

  '@media (max-width: 480px)': {
    container: {
      padding: '10px 5px',
    },

    card: {
      width: '100%',
      borderRadius: '9px',
    },

    content: {
      padding: '16px 9px',
    },

    highlightText: {
      fontSize: '0.98rem',
      lineHeight: '1.7',
      marginBottom: '16px',
    },

    mainText: {
      fontSize: '0.9rem',
      lineHeight: '1.75',
    },

    infoBox: {
      padding: '14px 9px',
      borderRight: '3px solid #3498db',
    },

    introText: {
      fontSize: '0.92rem',
      lineHeight: '1.75',
    },

    infoText: {
      fontSize: '0.86rem',
      lineHeight: '1.7',
    },

    expertBox: {
      flexDirection: 'row',
      gap: '7px',
      padding: '12px 7px',
      marginTop: '14px',
      marginBottom: '14px',
    },

    expertNumber: {
      minWidth: '30px',
      width: '30px',
      height: '30px',
      fontSize: '0.75rem',
    },

    expertTitle: {
      fontSize: '0.9rem',
    },

    smallText: {
      fontSize: '0.76rem',
    },

    subTitle: {
      fontSize: '0.85rem',
    },

    list: {
      paddingRight: '14px',
      fontSize: '0.78rem',
      lineHeight: '1.75',
    },

    processSection: {
      marginTop: '20px',
      paddingTop: '18px',
    },

    sectionTitle: {
      fontSize: '1rem',
      marginBottom: '15px',
    },

    processItem: {
      gap: '7px',
      padding: '10px 5px',
    },

    processNumber: {
      minWidth: '30px',
      width: '30px',
      height: '30px',
      fontSize: '0.62rem',
      borderRadius: '7px',
    },

    processTitle: {
      fontSize: '0.84rem',
    },

    smallInfoText: {
      fontSize: '0.77rem',
      lineHeight: '1.65',
    },

    goldenTip: {
      gap: '7px',
      padding: '12px 7px',
    },

    tipIcon: {
      minWidth: '29px',
      width: '29px',
      height: '29px',
      fontSize: '13px',
    },

    tipTitle: {
      fontSize: '0.88rem',
    },

    tipText: {
      fontSize: '0.77rem',
      lineHeight: '1.65',
    },

    requirementsSection: {
      marginTop: '20px',
      paddingTop: '18px',
    },

    item: {
      gap: '7px',
      padding: '10px 7px',
    },

    icon: {
      minWidth: '26px',
      width: '26px',
      height: '26px',
      fontSize: '13px',
    },

    itemTitle: {
      fontSize: '0.84rem',
    },

    itemText: {
      fontSize: '0.77rem',
      lineHeight: '1.55',
    },

    bottomNote: {
      padding: '10px 8px',
      fontSize: '0.77rem',
      gap: '7px',
    },

    noteIcon: {
      fontSize: '17px',
    },
  },

  /* =========================================
     מכשירים ממש קטנים עד 399px
     כאן אנחנו מונעים גלישה לרוחב
  ========================================= */

  '@media (max-width: 399px)': {
    container: {
      padding: '8px 3px',
      width: '100%',
    },

    card: {
      width: '100%',
      maxWidth: '100%',
      borderRadius: '8px',
    },

    content: {
      padding: '14px 7px',
      width: '100%',
      boxSizing: 'border-box',
    },

    highlightText: {
      fontSize: '0.9rem',
      lineHeight: '1.65',
    },

    mainText: {
      fontSize: '0.82rem',
      lineHeight: '1.7',
    },

    infoBox: {
      padding: '12px 7px',
      borderRight: '3px solid #3498db',
      borderRadius: '9px',
    },

    introText: {
      fontSize: '0.84rem',
      lineHeight: '1.7',
    },

    infoText: {
      fontSize: '0.78rem',
      lineHeight: '1.65',
    },

    expertBox: {
      gap: '5px',
      padding: '10px 5px',
    },

    expertNumber: {
      minWidth: '27px',
      width: '27px',
      height: '27px',
      fontSize: '0.68rem',
    },

    expertTitle: {
      fontSize: '0.82rem',
    },

    smallText: {
      fontSize: '0.7rem',
    },

    subTitle: {
      fontSize: '0.78rem',
    },

    list: {
      paddingRight: '12px',
      fontSize: '0.7rem',
      lineHeight: '1.7',
    },

    processSection: {
      marginTop: '17px',
      paddingTop: '15px',
    },

    sectionTitle: {
      fontSize: '0.9rem',
      marginBottom: '12px',
    },

    processItem: {
      gap: '5px',
      padding: '8px 3px',
    },

    processNumber: {
      minWidth: '27px',
      width: '27px',
      height: '27px',
      fontSize: '0.55rem',
    },

    processTitle: {
      fontSize: '0.78rem',
    },

    smallInfoText: {
      fontSize: '0.7rem',
      lineHeight: '1.6',
    },

    goldenTip: {
      gap: '5px',
      padding: '10px 5px',
    },

    tipIcon: {
      minWidth: '26px',
      width: '26px',
      height: '26px',
      fontSize: '12px',
    },

    tipTitle: {
      fontSize: '0.8rem',
    },

    tipText: {
      fontSize: '0.7rem',
      lineHeight: '1.6',
    },

    requirementsSection: {
      marginTop: '17px',
      paddingTop: '15px',
    },

    item: {
      gap: '5px',
      padding: '8px 5px',
    },

    icon: {
      minWidth: '24px',
      width: '24px',
      height: '24px',
      fontSize: '12px',
    },

    itemTitle: {
      fontSize: '0.78rem',
    },

    itemText: {
      fontSize: '0.7rem',
      lineHeight: '1.5',
    },

    bottomNote: {
      padding: '9px 6px',
      fontSize: '0.7rem',
      lineHeight: '1.5',
      gap: '5px',
    },

    noteIcon: {
      fontSize: '15px',
    },
  },
};